export default [
    { value: 'default', label: '-----', isDisabled: true },
    { value: 'number_employees', label: 'Number of Employees' },
    { value: 'number_iareps', label: 'IA Reps' },
    { value: 'number_bdreps', label: 'BD Reps' },
    { value: 'number_insurancelicensedreps', label: 'Insurance Licensed Reps'},
    { value: 'number_firmssolicitingclients', label: 'Firms Soliciting Clients'},
    { value: 'number_investmentadvisoryclients', label: 'Investment Advisory Clients'},
    { value: 'number_planningclients', label: 'Planning Clients' },
]